<div [formGroup]="formGroup" class="tw-flex tw-flex-col tw-gap-y-6 tw-w-full">
  <div class="tw-flex tw-gap-x-4 tw-items-start tw-min-w-max">
    <!-- デバイス種類 -->
    <mat-form-field
      appearance="outline"
      floatLabel="always"
      class="tw-w-[330px]"
    >
      <mat-label>
        <span>デバイス種類</span>
        @if (loadingDeviceSetting) {
          <mat-icon class="tw-animate-spin">progress_activity</mat-icon>
        }
      </mat-label>
      <mat-select
        formControlName="deviceType"
        name="deviceType"
        panelClass="matp-table-select-panel"
        required
      >
        @for (deviceType of deviceTypeList; track deviceType.id) {
          <mat-option [value]="deviceType.id">
            {{ deviceType.displayName }}
          </mat-option>
        }
      </mat-select>
      @if (
        formGroup.controls.deviceType.errors?.["required"] &&
        !loadingDeviceSetting
      ) {
        <mat-error>デバイス種類を選択してください</mat-error>
      }
    </mat-form-field>

    <!-- デバイス名 -->
    <mat-form-field
      appearance="outline"
      floatLabel="always"
      class="tw-w-[330px]"
    >
      <mat-label>
        <span>デバイス名</span>
        @if (loadingDeviceSetting) {
          <mat-icon class="tw-animate-spin">progress_activity</mat-icon>
        }
      </mat-label>
      <mat-select
        formControlName="deviceId"
        name="deviceName"
        panelClass="matp-table-select-panel"
        required
      >
        @for (
          deviceType of deviceListGroupByTypeId;
          track deviceType.deviceId
        ) {
          <mat-option [value]="deviceType.deviceId">
            {{ deviceType.deviceName || deviceType.deviceId }}
          </mat-option>
        }
      </mat-select>
      @if (
        formGroup.controls.deviceId.errors?.["required"] &&
        !loadingDeviceSetting
      ) {
        <mat-error>デバイスを選択してください</mat-error>
      }
    </mat-form-field>

    <div class="tw-flex tw-gap-x-4 tw-items-center tw-min-w-max">
      <!-- 表示のみだが、スタイルを合わせるためにmat-form-fieldを利用 -->
      <mat-form-field
        appearance="outline"
        floatLabel="always"
        class="matp-form-field-readonly"
      >
        <mat-label>設定グループ</mat-label>
        <input
          matInput
          name="deviceSettingGroup"
          readonly
          [value]="getSelectedDeviceSetting?.deviceSettingGroupName || 'なし'"
        />
      </mat-form-field>
    </div>
  </div>

  <!-- 配送センサーアラート取得開始時間 -->
  <!-- <app-datetime-picker
    [formGroup]="formGroup"
    controlName="sensorAlertGetTime"
    type="time"
    labelMessage="配送センサーアラート取得開始時間"
    [toolTipMessage]="tooltipMessage"
    width="330px"
  ></app-datetime-picker> -->
</div>
